<template>
  <div class="distributors">
    <v-container class="d-flex justify-center">
      <template>
        <v-card>
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Προμηθευτές</h1>
            <v-btn @click="refresh_data" icon><v-icon>mdi-refresh</v-icon></v-btn>
            <v-spacer/>
            <v-chip label outlined>
              {{
                new Intl.NumberFormat("el-GR", {
                  style: "currency",
                  currency: "EUR",
                }).format(filteredBalance)
              }}
            </v-chip>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              clearable
              hide-details
            ></v-text-field>
            <v-spacer/>
            <balance-filter-field
              :balance="balanceFilter"
              :mode="balanceFilterMode"
              @update:mode="balanceFilterMode = $event"
              @update:balance="balanceFilter = $event"
            />
            <v-spacer/>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  small
                  v-on="on"
                  @click="invoimportdialog = true"
                >
                <v-icon>mdi-upload</v-icon>
                </v-btn>
              </template>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  small
                  v-on="on"
                >
                <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Στοιχεία Προμηθευτή</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          label="Επωνυμία*"
                          v-model="supplierContact.name"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Τίτλος επιχείρισης"
                          v-model="supplierContact.CommerTitle"
                          hint="Εμπορική ονομασία"
                          persistent-hint
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <v-text-field
                          label="Supplier ID*"
                          v-model="supplierContact.Sid"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          label="Α.Φ.Μ.*"
                          v-model="supplierContact.Afm"
                          required
                        >
                       <template v-slot:append-outer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="fetchInfo"
                        >
                        <v-icon>mdi-account-arrow-down</v-icon>
                        </v-btn>
                       </template>
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-text-field
                          label="Διεύθυνση"
                          v-model="supplierContact.Address"
                          hint="Πλήρης Διεύθυνση"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8"
                             sm="6">
                        <v-text-field
                          label="ΔΟΥ*"
                          v-model="supplierContact.DoyDescr"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12"
                             sm="6">
                        <v-text-field
                          label="Περιοχή*"
                          v-model="supplierContact.City"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="Τηλέφωνο*"
                          v-model="supplierContact.Telephone"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <v-select
                          :items=firmActs
                          label="Εμπορική Δραστηριότητα"
                          v-model="supplierContact.FirmActDescr"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="6"
                      >
                        <v-text-field
                          label="Διεύθυνση Ηλεκτρονικού Ταχυδρομείου"
                          :rules="[rules.email]"
                          v-model="supplierContact.Email"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="6"
                      >
                        <v-text-field
                          label="Ιστοσελίδα"
                          v-model="supplierContact.Website"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <small>* Υποχρεωτικά πεδία</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialog = false"
                  >
                    Κλεισιμο
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="createSupplier"
                  >
                    Αποθηκευση
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          
           <v-tabs v-model="activeTab">
          <v-tab>List</v-tab>
          <v-tab>Treemap</v-tab>
        </v-tabs>
       <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <!-- Existing content for the list of distributors -->
          <v-data-table :headers="showHeaders" :items="distributors"
          :search="search" loading: false item-key="name" class="elevation-1"
          :items-per-page=15
          :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
          :height="$vuetify.breakpoint.height*0.7"
          dense

          :loading="loading" loading-text="Loading... Please wait"
          @click:row="clickrow" >
          <template v-slot:item.status="{ item }">
            <v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </template>

          <template v-slot:item.Afm="{ item }">
            <span v-if="isNaN(item.Afm)">000000000</span>
            <span v-else>{{
              new String(Number(item.Afm).toFixed()).padStart(9, "0")
            }}</span>
          </template>
          <template v-slot:item.Balance="{ item }">
            {{
              new Intl.NumberFormat("el-GR", {
                style: "currency",
                currency: "EUR",
              }).format(item.Balance)
            }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">More info about {{ item.name }}</td>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :href="'mailto:' + item.Email"
              v-if="item.Email"
            >
              <v-icon>mdi-email-edit</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              :href="item.Website"
              target="_blank"
              v-if="item.Website"
            >
              <v-icon>mdi-web</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              :to="'distributor/' + item.Id + '/info'"
            >
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              :to="'distributor/' + item.Id + '/invoices'"
            >
              <v-icon>mdi-file-document-multiple</v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn
              class="mr-2"
              icon
              small
              @click="showInvoDialog(item)"
            >
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              @click="showPaymDialog(item)"
            >
              <v-icon>mdi-cash-register</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <invoice-dialog :cid.sync="dialogcid" :dialog.sync="invodialog" />
        <invoice-import-dialog :dists.sync="distributors" :dialog.sync="invoimportdialog" />
        <payment-dialog :cid.sync="dialogcid" :dialog.sync="paymdialog" apipath="suppliers/debits" />

          </v-tab-item>
          <v-tab-item>
    <v-container fluid class="d-flex flex-column">
      <template>

            <v-card
              class="mt-4 mx-auto"
              min-width="120%"
            >
            <v-sheet
              class="v-sheet--offset ma-2"
              color="white"
              elevation="0"
            >
              <apexchart
                ref="distributorTreemap"
                type="treemap"
                :options="treemapOptions"
                :series="distributorSeries"
              ></apexchart>

            </v-sheet>

    <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Αγορές ανταλλακτικών
      </div>
      <div class="subheading font-weight-light grey--text">
        Σύνολο αγορών ανα προμηθευτή για το διάστημα.
        <p>(Σύνολική αξία ανταλλακτικών {{ $tocurr(balance) }})</p>
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-clock
      </v-icon>
      <span class="text-caption grey--text font-weight-light">last registration 26 minutes ago</span>
    </v-card-text>
    </v-card>
    </template>
    </v-container>
  </v-tab-item>
        </v-tabs-items>

        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

import {sumBy as _sumBy} from 'lodash';
import {orderBy as _orderBy} from 'lodash';
import PaymentDialog from '../components/PaymentDialog.vue';
import InvoiceDialog from '../components/InvoiceDialog.vue';
import InvoiceImportDialog from '../components/InvoiceImportDialog.vue';
import BalanceFilterField from '../components/BalanceFilterField.vue';


export default {
  components: {
    PaymentDialog,
    InvoiceDialog,
    InvoiceImportDialog,
    BalanceFilterField,
    apexchart: VueApexCharts,
  },
  computed: {
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["Cid", "Afm", "Address"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
    filteredBalance() {
      if (!this.balanceFilter) return _sumBy(this.distributors, "Balance");
      if (this.balanceFilterMode === "above") {
        return _sumBy(this.distributors.filter(e=>e.Balance >= this.balanceFilter), "Balance");
      } else {
        return _sumBy(this.distributors.filter(e=>e.Balance <= this.balanceFilter), "Balance");
      }
    },
  },
  data() {
    return {
      rules:  {
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
      },
      activeTab: 0,
      distributors: [],
      loading: true,
      dialog: false,
      invodialog: false,
      invoimportdialog: false,
      paymdialog: false,
      dialogcid: 0,
      balance: 0.0,
      balanceFilter: 0.0,
      balanceFilterMode: "above", // NEW

      search: "",
      supplierContact: {
        name: "",
        Address: "",
        City: "",
        DoyDescr: "",
        Telephone: "",
        FirmActDescr: "",
        Sid: "",
      },
      firmActs: [],
      headers: [
        {
          text: "Προμηθευτής",
          align: "start",
          //sortable: false,
          value: "Name",
          width: "30%",
        },
        { text: "Κωδικός", value: "Cid" },
        { text: "ΑΦΜ", value: "Afm" },
        { text: "Διεύθυνση", value: "Address" },
        { text: "Τηλέφωνο", value: "Telephone" },
        { text: "Υπόλοιπο", value: "Balance", align: "end",
          filter: (value) => {
          if (!this.balanceFilter) return true;
          if (this.balanceFilterMode === "above") return value >= this.balanceFilter;
          else return value <= this.balanceFilter;
          },
        },
        //{ text: "Status", value: "balance.currency" },
        { text: "Actions", value: "actions", sortable: false },
        //{ text: '', value: 'data-table-expand' },
      ],
      treemapOptions: {
        chart: {
          type: "treemap",
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
        },
        tooltip: {
          enabled: true,
          y: {
            title: {
              formatter: function(val) {
                return val.length > 15 ? val.slice(0, 15) + '...' : val;
              },
            },
            formatter: this.$tocurr,
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '18px',
          },
          formatter: this.currencyFmtTree,
          offsetY: -4,
        },
        plotOptions: {
          treemap: {
            enableShades: true,
          },
        },
      },
      distributorSeries: [],
    };
  },
  async created() {
    await this.fetchData();
  },
  
  async mounted() {
    this.loadDistributorData();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },


    currencyFmtTree(text, op) {
      let pcnt =  ((op.value / this.balance * 100)).toFixed(2);
      return [text, this.$tocurr(op.value) +  " ("  +pcnt + "%)" ];
    },
    loadDistributorData() {
      // Logic to load distributor data and set distributorSeries
      this.distributorSeries = _orderBy(this.distributors.filter(dist => dist.Balance > 200), 'Balance', 'desc').map(distributor => ({
        name: distributor.Name,
        data: [{ x: distributor.Name, y: distributor.Balance }]
      }));
    },
    async refresh_data () {
      this.loading = true;
      const response = await this.$api.get("/suppliers/", { clearCache: true } );
        this.distributors = response.data;
        this.balance = _sumBy(this.distributors, "Balance");
      this.loading = false;
    },
    async fetchData() {

      // GET request using fetch with async/await
      try {

        const response = await this.$api.get("/suppliers/");
        this.distributors = response.data;

        //const resp = await this.$api.get("/balance");
        this.balance = _sumBy(this.distributors, "Balance");
        this.loading = false;
        this.loadDistributorData();
      } catch (error) {
        console.error(error);
      }

    },

    async fetchInfo() {
      var response = await this.$api.get("/vat-info/"+this.supplierContact.Afm);
      var contact = response.data;
      this.supplierContact.name = contact.Onomasia;
      this.supplierContact.Address = contact.Address;
      this.supplierContact.Afm = contact.Afm;
      this.supplierContact.CommerTitle = contact.CommerTitle;
      this.supplierContact.DoyDescr = contact.DoyDescr;
      this.supplierContact.City = contact.PostalAreaDescription;
      this.firmActs = [];
      for (var i in contact.FirmActivity) {
        this.firmActs.push(contact.FirmActivity[i].FirmActDescr);
      }
    },

    async createSupplier() {
      let supplier = this.supplierContact;
      var response = await this.$api.post("/suppliers/", supplier);
      console.log(response);
      this.dialog = false;
      this.refresh_data();
    },
    showInvoDialog(item) {
      this.dialogcid = item.Id;
      this.invodialog = true;
    },
    showPaymDialog(item) {
      this.dialogcid = item.Id;
      this.paymdialog = true;
    },
    sortBy(prop) {
      this.distributors.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    getColor(status) {
      if (status === "complete") return "green";
      else if (status === "overdue") return "red";
      else return "";
    },
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}
</style>
